import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Chip from "../../../../components/basics/Chip";
import TableDefault from "../../../../components/grid/TableDefault";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Prescricao";

const columnsDependents = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
    style: { width: 100 },
    format: (item) => (
      <SpeedDialErp
        actions={[
          {
            icon: <EditOutlinedIcon />,
            name: "Editar",
            action: () => {},
          },
          {
            icon: <EditOutlinedIcon />,
            name: "Editar",
            action: () => {},
          },
          {
            icon: <EditOutlinedIcon />,
            name: "Editar",
            action: () => {},
          },
        ]}
      />
    ),
  },
  {
    id: "id",
    label: "Id",
    align: "center",
    style: { width: 100 },
  },
  {
    id: "razao",
    label: "Nome",
  },
  {
    id: "apelido",
    label: "Apelido",
    align: "center",
  },
];

// botão de ação no dependente para exibir histórico de prescrições dele

const AccordionPrescricaoDependentes = ({ ...props }) => {
  const { handleChangeOpenAcordion, handleOpenPrescriptionModal } =
    usePrescricaoController();
  const { expanded, dependents, loading } = useContext(PrescricaoContext);

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.dependents || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("dependents")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("dependents")}
                >
                  <Chip label="DEPENDENTES" bgcolor={"default"} />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar prescrição de dependente">
                    <IconButtonStyled
                      onClick={() => handleOpenPrescriptionModal(true)}
                    >
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        loading={loading.tables ? true : false}
                        columns={columnsDependents}
                        values={dependents}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionPrescricaoDependentes;
